// extracted by mini-css-extract-plugin
module.exports = {"loader":"ContentLoader_loader__7Ypp4","waveAnimation":"ContentLoader_waveAnimation__fWJ7C","marquee":"ContentLoader_marquee__0874g"};